import React from "react";
import { IconPropsType } from "./types";

interface IDoubleArrowIconProps extends IconPropsType {}

const DoubleArrowIcon = ({
  size = 24,
  stroke = "var(--rhino)",
  strokeWidth = 1.25,
  ...props
}: IDoubleArrowIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16 14L12 18L8 14M8 10L12 6L16 10"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DoubleArrowIcon;
